import { Api as api } from "../api";
const prefix = "/master-data";
// const prefix = "";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    freezerModelServiceV1ListFreezerBrands: build.query<
      FreezerModelServiceV1ListFreezerBrandsApiResponse,
      FreezerModelServiceV1ListFreezerBrandsApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/freezer-brands`,
        params: {
          name: queryArg.name,
        },
      }),
    }),
    freezerModelServiceV1CreateFreezerBrand: build.mutation<
      FreezerModelServiceV1CreateFreezerBrandApiResponse,
      FreezerModelServiceV1CreateFreezerBrandApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/freezer-brands`,
        method: "POST",
        body: queryArg.freezerModelV1CreateFreezerBrandReq,
      }),
    }),
    freezerModelServiceV1ListFreezerModels: build.query<
      FreezerModelServiceV1ListFreezerModelsApiResponse,
      FreezerModelServiceV1ListFreezerModelsApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/freezer-models`,
        params: {
          page: queryArg.page,
          size: queryArg.size,
          sort_by: queryArg.sortBy,
          sort_order: queryArg.sortOrder,
          status: queryArg.status,
          freezer_brand: queryArg.freezerBrand,
          freezer_model_name: queryArg.freezerModelName,
          created_at_from: queryArg.createdAtFrom,
          created_at_to: queryArg.createdAtTo,
          updated_at_from: queryArg.updatedAtFrom,
          updated_at_to: queryArg.updatedAtTo,
        },
      }),
    }),
    freezerModelServiceV1BatchCreateFreezerModel: build.mutation<
      FreezerModelServiceV1BatchCreateFreezerModelApiResponse,
      FreezerModelServiceV1BatchCreateFreezerModelApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/freezer-models`,
        method: "POST",
        body: queryArg.freezerModelV1BatchCreateFreezerModelReq,
      }),
    }),
    freezerModelServiceV1ActivateFreezerModels: build.mutation<
      FreezerModelServiceV1ActivateFreezerModelsApiResponse,
      FreezerModelServiceV1ActivateFreezerModelsApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/freezer-models/activate`,
        method: "PATCH",
        body: queryArg.freezerModelV1FreezerModelBulkStatusChangeReq,
      }),
    }),
    freezerModelServiceV1DeactivateFreezerModels: build.mutation<
      FreezerModelServiceV1DeactivateFreezerModelsApiResponse,
      FreezerModelServiceV1DeactivateFreezerModelsApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/freezer-models/inactive`,
        method: "PATCH",
        body: queryArg.freezerModelV1FreezerModelBulkStatusChangeReq,
      }),
    }),
    freezerModelServiceV1GetFreezerModel: build.query<
      FreezerModelServiceV1GetFreezerModelApiResponse,
      FreezerModelServiceV1GetFreezerModelApiArg
    >({
      query: (queryArg) => ({ url: `${prefix}/v1/freezer-models/${queryArg.id}` }),
    }),
    freezerModelServiceV1UpdateFreezerModel: build.mutation<
      FreezerModelServiceV1UpdateFreezerModelApiResponse,
      FreezerModelServiceV1UpdateFreezerModelApiArg
    >({
      query: (queryArg) => ({
        url: `${prefix}/v1/freezer-models/${queryArg.id}`,
        method: "PUT",
        body: queryArg.freezerModelServiceV1UpdateFreezerModelBody,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as freezerModelApi };
export type FreezerModelServiceV1ListFreezerBrandsApiResponse =
  /** status 200 A successful response. */ FreezerModelV1ListFreezerBrandsRes;
export type FreezerModelServiceV1ListFreezerBrandsApiArg = {
  name?: string;
};
export type FreezerModelServiceV1CreateFreezerBrandApiResponse =
  /** status 200 A successful response. */ FreezerModelV1FreezerModelMessageRes;
export type FreezerModelServiceV1CreateFreezerBrandApiArg = {
  freezerModelV1CreateFreezerBrandReq: FreezerModelV1CreateFreezerBrandReq;
};
export type FreezerModelServiceV1ListFreezerModelsApiResponse =
  /** status 200 A successful response. */ FreezerModelV1ListFreezerModelsRes;
export type FreezerModelServiceV1ListFreezerModelsApiArg = {
  page?: number;
  size?: number;
  sortBy?: string;
  sortOrder?: string;
  status?: string;
  freezerBrand?: string;
  freezerModelName?: string;
  createdAtFrom?: string;
  createdAtTo?: string;
  updatedAtFrom?: string;
  updatedAtTo?: string;
};
export type FreezerModelServiceV1BatchCreateFreezerModelApiResponse =
  /** status 200 A successful response. */ FreezerModelV1FreezerModelMessageRes;
export type FreezerModelServiceV1BatchCreateFreezerModelApiArg = {
  freezerModelV1BatchCreateFreezerModelReq: FreezerModelV1BatchCreateFreezerModelReq;
};
export type FreezerModelServiceV1ActivateFreezerModelsApiResponse =
  /** status 200 A successful response. */ FreezerModelV1FreezerModelBulkStatusChangeRes;
export type FreezerModelServiceV1ActivateFreezerModelsApiArg = {
  freezerModelV1FreezerModelBulkStatusChangeReq: FreezerModelV1FreezerModelBulkStatusChangeReq;
};
export type FreezerModelServiceV1DeactivateFreezerModelsApiResponse =
  /** status 200 A successful response. */ FreezerModelV1FreezerModelBulkStatusChangeRes;
export type FreezerModelServiceV1DeactivateFreezerModelsApiArg = {
  freezerModelV1FreezerModelBulkStatusChangeReq: FreezerModelV1FreezerModelBulkStatusChangeReq;
};
export type FreezerModelServiceV1GetFreezerModelApiResponse =
  /** status 200 A successful response. */ FreezerModelV1FreezerModelDetailRes;
export type FreezerModelServiceV1GetFreezerModelApiArg = {
  id: string;
};
export type FreezerModelServiceV1UpdateFreezerModelApiResponse =
  /** status 200 A successful response. */ FreezerModelV1FreezerModelMessageRes;
export type FreezerModelServiceV1UpdateFreezerModelApiArg = {
  id: string;
  freezerModelServiceV1UpdateFreezerModelBody: FreezerModelServiceV1UpdateFreezerModelBody;
};
export type FreezerModelV1FreezerBrandRes = {
  id?: string;
  name?: string;
  created_at?: string;
  created_by?: string;
};
export type FreezerModelV1ListFreezerBrandsRes = {
  freezer_brands?: FreezerModelV1FreezerBrandRes[];
};
export type ProtobufAny = {
  "@type"?: string;
  [key: string]: any;
};
export type RpcStatus = {
  code?: number;
  message?: string;
  details?: ProtobufAny[];
};
export type FreezerModelV1FreezerModelMessageRes = {
  message?: string;
  id?: string;
};
export type FreezerModelV1CreateFreezerBrandReq = {
  name: string;
};
export type FreezerModelV1FreezerModelRes = {
  id?: string;
  freezer_brand_id?: string;
  freezer_brand_name?: string;
  freezer_model_name?: string;
  fuel_efficiency?: number;
  status?: string;
  created_by?: string;
  updated_by?: string;
  created_at?: string;
  updated_at?: string;
};
export type FreezerModelV1FreezerModelPaginationMeta = {
  total?: number;
  current_page?: number;
  limit?: number;
  total_item?: number;
  total_page?: number;
  have_next_page?: boolean;
  have_previous_page?: boolean;
};
export type FreezerModelV1ListFreezerModelsRes = {
  freezer_models?: FreezerModelV1FreezerModelRes[];
  metadata?: FreezerModelV1FreezerModelPaginationMeta;
};
export type FreezerModelV1CreateFreezerModelItem = {
  freezer_brand_id: string;
  freezer_model_name: string;
  fuel_efficiency: number;
  status: string;
};
export type FreezerModelV1BatchCreateFreezerModelReq = {
  freezer_models: FreezerModelV1CreateFreezerModelItem[];
};
export type FreezerModelV1FreezerModelBulkStatusChangeRes = {
  message?: string;
  updated_count?: number;
};
export type FreezerModelV1FreezerModelBulkStatusChangeReq = {
  ids: string[];
};
export type FreezerModelV1FreezerModelDetailRes = {
  id?: string;
  freezer_brand_id?: string;
  freezer_brand_name?: string;
  freezer_model_name?: string;
  fuel_efficiency?: number;
  status?: string;
  created_by?: string;
  updated_by?: string;
  created_at?: string;
  updated_at?: string;
};
export type FreezerModelServiceV1UpdateFreezerModelBody = {
  freezer_model_name: string;
  fuel_efficiency: number;
};
export const {
  useFreezerModelServiceV1ListFreezerBrandsQuery,
  useFreezerModelServiceV1CreateFreezerBrandMutation,
  useFreezerModelServiceV1ListFreezerModelsQuery,
  useFreezerModelServiceV1BatchCreateFreezerModelMutation,
  useFreezerModelServiceV1ActivateFreezerModelsMutation,
  useFreezerModelServiceV1DeactivateFreezerModelsMutation,
  useFreezerModelServiceV1GetFreezerModelQuery,
  useFreezerModelServiceV1UpdateFreezerModelMutation,
} = injectedRtkApi;
